module.exports = __webpack_public_path__ + "img/i_check.a159889c.svg";